import { useCallback, useEffect, useState } from 'react';

interface Collection<T> {
  items: T[] | null;
  error: string | null;
  reload: () => void;
}

/** Laddar en admin-lista och gör det enkelt att hämta om efter en ändring. */
export function useCollection<T>(load: () => Promise<T[]>): Collection<T> {
  const [items, setItems] = useState<T[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(() => {
    load()
      .then((data) => {
        setItems(data);
        setError(null);
      })
      .catch(() => setError('Listan kunde inte hämtas.'));
  }, [load]);

  useEffect(reload, [reload]);

  return { items, error, reload };
}
